import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { wrapIntoFragment } from '@infl-ts/ui-wrap-into-fragment';
import { useToggle } from '@infl-ts/util-hooks';
import { useEffect } from 'react';
export var ClientSideRender = function ClientSideRender(_ref) {
  var children = _ref.children;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isClientSide = _useToggle2[0],
      setClientSide = _useToggle2[1].on;

  useEffect(function () {
    setClientSide();
  }, []);
  return isClientSide ? wrapIntoFragment(children) : null;
};